/** Shared author-facing diagnostics; only error severity blocks Flow preparation. */
import React, { useState } from 'react';
import { Message, Button, Accordion, Icon } from 'semantic-ui-react';
import { AVAILABLE_TRANSLATION_LANGUAGES } from '../../../constants/translations';
const languageName = code => AVAILABLE_TRANSLATION_LANGUAGES.find(item => item.value === code)?.text || code;
export const visibleFlowDiagnostics = diagnostics => (diagnostics || []).filter(d =>
  d && !['stale_option_translations', 'language_catalogue_fallback'].includes(d.code) && typeof d.message === 'string' && d.message.trim());
export default function FlowDiagnostics({ diagnostics = [], ignoredItems = [], onSection }) {
  const [open, setOpen] = useState(false);
  const [skippedOpen, setSkippedOpen] = useState(false);
  const skipped = visibleFlowDiagnostics(ignoredItems);
  const visible = visibleFlowDiagnostics(diagnostics);
  if (!visible.length && !skipped.length) return null;
  const errors = visible.filter(d => d.severity !== 'warning').length;
  return <>{!!visible.length && <Accordion fluid>
    <Accordion.Title active={open} onClick={() => setOpen(value => !value)}>
      <button type="button" className="ui basic button" aria-expanded={open}>
        <Icon name="dropdown" />
        {errors ? `${errors} Flow issue${errors === 1 ? '' : 's'} to resolve` : `${visible.length} Flow preparation note${visible.length === 1 ? '' : 's'}`}
      </button>
    </Accordion.Title>
    <Accordion.Content active={open} hidden={!open}>{visible.map((d, i) => {
    const warning = d.severity === 'warning';
    const sections = Array.isArray(d.sections) ? d.sections : [];
    return <Message visible color={warning ? 'orange' : 'red'} key={`${d.code}-${d.recordId}-${i}`}>
      <Message.Header>{warning ? 'How this Flow was prepared' : 'This needs fixing before the Flow is ready'}</Message.Header>
      {!!sections.length && <p><strong>Section:</strong> {sections.map(s => s.name).join(' → ')}</p>}
      {d.recordName && <strong>{d.recordName}</strong>}
      {d.lookupName && <p><strong>Lookup:</strong> {d.lookupName}</p>}
      {d.option && <p><strong>Answer option:</strong> {d.option}</p>}
      {!!d.languages?.length && <p><strong>Language:</strong> {d.languages.map(languageName).join(', ')}</p>}
      <p>{d.message}</p>
      {Number.isFinite(d.screenCount) && Number.isFinite(d.screenLimit) &&
        <p><strong>Screen count:</strong> {d.screenCount} / {d.screenLimit}</p>}
      {onSection && sections[0]?.id && <Button type="button" size="small" basic onClick={() => onSection(sections[0].id)}>Open section</Button>}
      {(d.recordId || d.code) && <details><summary>Support references</summary>
        {d.code && <p>Issue: <code>{d.code}</code></p>}
        {d.recordId && <p>Item: <code>{d.recordId}</code></p>}
        {d.lookupId && <p>Lookup: <code>{d.lookupId}</code></p>}
      </details>}
    </Message>;
  })}</Accordion.Content></Accordion>}
    {!!skipped.length && <Accordion fluid>
      <Accordion.Title active={skippedOpen} onClick={() => setSkippedOpen(value => !value)}>
        <button type="button" className="ui basic button" aria-expanded={skippedOpen}>
          <Icon name="dropdown" />Skipped items ({skipped.length})
        </button>
      </Accordion.Title>
      <Accordion.Content active={skippedOpen} hidden={!skippedOpen}>
        <p>The compiler handled these items automatically. The explanation for each item states what was skipped or adjusted; these notes do not prevent preparation.</p>
        {skipped.map((item, index) => <Message key={`${item.code}-${item.recordId}-${index}`}>
          {item.recordName && <Message.Header>{item.recordName}</Message.Header>}
          {!!item.sections?.length && <p>Section: {item.sections.map(section => section.name).join(' → ')}</p>}
          <p>{item.message}</p>
          {item.recordId && <details><summary>Support reference</summary><code>{item.recordId}</code></details>}
        </Message>)}
      </Accordion.Content>
    </Accordion>}
  </>;
}
